import { MinLength } from 'class-validator';

export class ConfirmEmailModel {
  @MinLength(2)
  public token: string;

  constructor(
    token: string
  ) {
    this.token = token;
  }
}
